import {
  CANADA_STATES,
  CANADA_TERRITORIES,
  JURISDICTION_AREAS,
  UNITED_STATES_STATES,
  UNITED_STATES_TERRITORIES,
} from '@components/CaseSettingsBlocks/Jurisdiction/utils';

const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/u;

const phoneRegex = /^[\d\-()\s\\+]{7,}$/u;

const addressRegexes = [/^\d+\s+[\w\s.,#'-]+$/u, /^[\w\s.,#'-]{3,}$/u];

export const JURISDICTION_MATCHING_VALUES = [
  ...UNITED_STATES_STATES.map((s) => s.label.toLowerCase()),
  ...UNITED_STATES_STATES.map((s) => s.value.toLowerCase()),
  ...UNITED_STATES_TERRITORIES.map((s) => s.label.toLowerCase()),
  ...UNITED_STATES_TERRITORIES.map((s) => s.value.toLowerCase()),
  ...CANADA_STATES.map((s) => s.label.toLowerCase()),
  ...CANADA_STATES.map((s) => s.value.toLowerCase()),
  ...CANADA_TERRITORIES.map((s) => s.label.toLowerCase()),
  ...CANADA_TERRITORIES.map((s) => s.value.toLowerCase()),
];

export const COUNTRY_VALUES = [
  ...JURISDICTION_AREAS.map((area) => area.label),
  ...JURISDICTION_AREAS.map((area) => area.value),
];

export const EXPECTED_COLUMN_FIELDS = [
  {
    key: 'caseID',
    labels: ['caseID', 'case_id', 'Case ID'],
  },
  {
    key: 'adminID',
    labels: ['adminID', 'admin_id', 'Admin ID'],
  },
  {
    key: 'submissionDate',
    labels: [
      'submissionDate',
      'submission_date',
      'Submission Date',
      'Submitted At',
      'Date Submitted',
    ],
    valueRegex: [
      // 2025-06-25
      /^\d{4}-\d{2}-\d{2}$/u,
      // 06/25/2025
      /^\d{2}\/\d{2}\/\d{4}$/u,
      // 2025/06/25
      /^\d{4}\/\d{2}\/\d{2}$/u,
      // 25-Jun-2025
      /^\d{2}-[A-Za-z]{3}-\d{4}$/u,
    ],
  },
  {
    key: 'claimType',
    labels: ['claimType', 'claim_type', 'Claim Type'],
  },
  {
    key: 'firstName',
    labels: ['firstName', 'first_name', 'First Name'],
  },
  {
    key: 'lastName',
    labels: ['lastName', 'last_name', 'Last Name'],
  },
  {
    key: 'address',
    labels: ['address', 'Address', 'address1', 'Address 1'],
    valueRegex: addressRegexes,
  },
  {
    key: 'address2',
    labels: ['address2', 'Address2', 'Address 2', 'address_line2'],
    valueRegex: addressRegexes,
  },
  {
    key: 'city',
    labels: ['city', 'City'],
    valueRegex: /^[A-Za-z\u00C0-\u017F\s.'-]{2,}$/u,
  },
  {
    key: 'states',
    labels: ['states', 'States', 'state', 'State', 'province', 'Province'],
    allowedValues: JURISDICTION_MATCHING_VALUES,
  },
  {
    key: 'zip',
    labels: ['zip', 'Zip', 'zipcode', 'Zip Code'],
    valueRegex: [
      // US
      /^\d{5}(?:-\d{4})?$/u,
      // Canada
      /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/u,
    ],
  },
  {
    key: 'country',
    labels: ['country', 'Country'],
    allowedValues: COUNTRY_VALUES,
  },
  {
    key: 'unvalidatedEmail',
    labels: ['unvalidatedEmail', 'Unvalidated Email', 'unvalidated_email'],
    valueRegex: emailRegex,
  },
  {
    key: 'validatedEmail',
    labels: ['validatedEmail', 'Validated Email', 'validated_email'],
    valueRegex: emailRegex,
  },
  {
    key: 'paymentEmail',
    labels: ['paymentEmail', 'Payment Email', 'payment_email'],
    valueRegex: emailRegex,
  },
  {
    key: 'unvalidatedPhone',
    labels: ['unvalidatedPhone', 'Unvalidated Phone', 'unvalidated_phone'],
    valueRegex: phoneRegex,
  },
  {
    key: 'validatedPhone',
    labels: ['validatedPhone', 'Validated Phone', 'validated_phone'],
    valueRegex: phoneRegex,
  },
  {
    key: 'paymentPhone',
    labels: ['paymentPhone', 'Payment Phone', 'payment_phone'],
    valueRegex: phoneRegex,
  },
  {
    key: 'units',
    labels: ['units', 'Units'],
    valueRegex: /^\d+$/u,
  },
  {
    key: 'ipAddress',
    labels: ['ipAddress', 'IP Address', 'ip_address'],
    valueRegex: /^(?:\d{1,3}\.){3}\d{1,3}$/u,
  },
  {
    key: 'referrer',
    labels: ['referrer', 'Referrer'],
  },
  {
    key: 'mailedIn',
    labels: ['mailedIn', 'Mailed In', 'mailed_in'],
  },
  {
    key: 'submitterType',
    labels: ['submitterType', 'Submitter Type', 'submitter_type'],
  },
  {
    key: 'uniquePayoutAmount',
    labels: [
      'uniquePayoutAmount',
      'Unique Payout Amount',
      'unique_payout_amount',
    ],
    valueRegex: /^\d+(?:\.\d{2})?$/u,
  },
  {
    key: 'passesCaseSpecificValidation',
    labels: [
      'passesCaseSpecificValidation',
      'Passes Case Specific Validation',
      'passes_case_specific_validation',
    ],
  },
  {
    key: 'classMemberID',
    labels: ['classMemberID', 'Class Member ID', 'class_member_id'],
  },
  {
    key: 'authenticationPin',
    labels: ['authenticationPin', 'Authentication PIN', 'authentication_pin'],
    valueRegex: /^\d{4,8}$/u,
  },
  {
    key: 'artifactPaidAmount',
    labels: [
      'artifactPaidAmount',
      'Artifact Paid Amount',
      'artifact_paid_amount',
    ],
    valueRegex: /^\d+(?:\.\d{2})?$/u,
  },
];

export const COLUMN_NUMBER_MIN = 13;
export const MATCH_THRESHOLD = 0.7;
